export const MODULE_I18_PREFIX = 'busy' as const;
